import { Theme } from '@mui/material';

export type PolicySeverity = 'restriction' | 'warning' | 'info';

export const SEVERITY_LABELS: Record<PolicySeverity, string> = {
  restriction: 'Restriction',
  warning: 'Warning',
  info: 'Guidance',
};

const TYPE_SEVERITY_MAP: Record<string, PolicySeverity> = {
  restriction: 'restriction',
  warning: 'warning',
  requirement: 'info',
  guideline: 'info',
};

/**
 * Severity says how firm a rule is, so it reads from `type` in every category,
 * escalation included. An escalation policy is authored as `requirement` and is
 * never a restriction — how soon it has to be answered is carried by its urgency
 * icon, not by this scale, and must not reach the category restriction badge.
 */
export const getSeverityForType = (type?: string | null): PolicySeverity =>
  TYPE_SEVERITY_MAP[type ?? ''] ?? 'info';

export interface SeverityColors {
  glyph: string;
  rail: string;
}

export const getSeverityColors = (theme: Theme, severity: PolicySeverity): SeverityColors => {
  const { sys, extended } = theme.palette.custom.OV;

  switch (severity) {
    case 'restriction':
      return { glyph: sys.error, rail: sys.error };
    case 'warning':
      return { glyph: extended.Signature.color, rail: extended.Signature.color };
    default:
      return { glyph: sys.onSurfaceVariant, rail: sys.outlineVariant };
  }
};
